export enum LoanGradeType {
    Grade9 = 9,
    Grade10 = 10,
    Grade11 = 11,
    Grade12 = 12,
    Grade13 = 13,
    Grade14 = 14,
    Grade15 = 15,
}

export const LoanGradeTypeOptions = [
    { id: LoanGradeType.Grade9, name: '9', isLoc: false },
    { id: LoanGradeType.Grade10, name: '10', isLoc: false },
    { id: LoanGradeType.Grade11, name: '11', isLoc: false },
    { id: LoanGradeType.Grade12, name: '12', isLoc: false },
    { id: LoanGradeType.Grade13, name: '13', isLoc: false },
    { id: LoanGradeType.Grade14, name: '14', isLoc: true },
    { id: LoanGradeType.Grade15, name: '15', isLoc: true },
];
